import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterState, RouterStateModel } from '@ngxs/router-plugin';
import { Selector, createSelector } from '@ngxs/store';

export class RouterSelectors {
  @Selector([RouterState])
  static getRouteId(state: RouterStateModel) {
    return this.findRouteId(state.state.root);
  }

  static getRoutePathParam(paramId: string) {
    return createSelector([RouterState], (state: RouterStateModel) => {
      return this.findRoutePathParam(state.state.root, paramId);
    });
  }

  @Selector([RouterState])
  static getRoute(state: RouterStateModel) {
    return state.state.root.firstChild.url[0].path;
  }

  @Selector([RouterState])
  static getRoutePath(state: RouterStateModel) {
    return state.state.url;
  }

  @Selector([RouterState])
  static getAuxiliaryRoute(state: RouterStateModel): string {
    let route = state.state.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.url[0]?.path || '';
  }

  @Selector([RouterState])
  static getRouteFragment(state: RouterStateModel) {
    return state.state.root.fragment;
  }

  private static findRouteId(branch: ActivatedRouteSnapshot): string {
    if (branch.paramMap.has('id')) return branch.paramMap.get('id');
    for (const childBranch of branch.children) {
      return this.findRouteId(childBranch);
    }
    return null;
  }

  private static findRoutePathParam(
    branch: ActivatedRouteSnapshot,
    paramId: string
  ): string {
    if (branch.paramMap.has(paramId)) return branch.paramMap.get(paramId);
    for (const childBranch of branch.children) {
      return this.findRoutePathParam(childBranch, paramId);
    }
    return null;
  }
}
